export default __webpack_public_path__ + "static/media/2148.60db9e9c.png";